import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetFavorites = (typeId: number, isDefault?: boolean) => {
    const { zoneApiClient } = useZoneContext();

    return useQuery({
        queryKey: ['get-favorites', { typeId, def: isDefault }],
        queryFn: async () => {
            const response = await zoneApiClient.getFavorites(typeId, isDefault);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve favorites.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
    });
};
